export default __webpack_public_path__ + "static/media/icon-check.def9d3bf.svg";